import React from 'react'
import { retry } from '../../common/src/retry'

export const LazyIViewPlaceholder = React.lazy(() => retry(() => import('./IViewPlaceholder')))
